<template>
	<div class="row">
		<div class="col-sm-12 col-md-7 align-self-center">
			<div class="col">
				<div class="row">
					<div class="col-lg-6 col-xs-12 mt-1">
						<div class="row">
							<div class="align-self-center mr-1">
								Data per page:
							</div>
							<div>
								<select v-model="limit" style="border: 0px; outline: 0px;">                        
									<option value="10">10</option>
									<option value="20">20</option>
									<option value="30">30</option>
									<option value="40">40</option>
									<option value="50">50</option>
								</select>
							</div>
						</div>
					</div>
					<div class="col-lg-6 col-xs-12 p-0 mt-1" v-if="data.currentPage != data.totalPages">
						Showing {{ (data.currentPage - 1) * data.perPage + 1 }} - {{ (data.currentPage * data.perPage) }} from {{ data.count ? data.count : 0 }} data
					</div>
					<div class="col-lg-6 col-xs-12 p-0 mt-1" v-else>
						Showing {{ (data.currentPage - 1) * data.perPage + 1 }} - {{ (data.currentPage * data.perPage) - data.perPage + data.countPerPage }} from {{ data.count ? data.count : 0 }} data
					</div>
				</div>
			</div>

		</div>
	    <div class="col-sm-12 col-md-5">
	        <div class="dataTables_paginate paging_simple_numbers">
				<!-- MOBILE ONLY -->
	            <ul class="pagination mb-0 justify-content-center mt-1 d-lg-none">
	                <li class="paginate_button page-item previous" :class="{ disabled: data.currentPage <= 1 }">
	                    <button type="button" class="page-link" @click.prevent="changePage(data.currentPage - 1)"></button>
	                </li>

					<li class="paginate_button page-item" v-for="(page, key) in pages" :key="key" :class="isCurrentPage(page) ? 'active' : ''">
						<button type="button" class="page-link" @click.prevent="changePage(page)">{{ page }}</button>
					</li>

	                <li class="paginate_button page-item next" :class="{ disabled: data.currentPage >= data.totalPages }">
	                    <button type="button" class="page-link" @click.prevent="changePage(data.currentPage + 1)"></button>
	                </li>
	            </ul>

				<!-- DESKTOP ONLY -->
				<div class="d-lg-block d-none">
					<ul class="pagination mb-0 pull-right mt-1">
						<li class="paginate_button page-item previous" :class="{ disabled: data.currentPage <= 1 }">
							<button type="button" class="page-link" @click.prevent="changePage(data.currentPage - 1)">Previous</button>
						</li>

						<li class="paginate_button page-item" v-for="(page, key) in pages" :key="key" :class="isCurrentPage(page) ? 'active' : ''">
							<button type="button" class="page-link" @click.prevent="changePage(page)">{{ page }}</button>
						</li>

						<li class="paginate_button page-item next" :class="{ disabled: data.currentPage >= data.totalPages }">
							<button type="button" class="page-link" @click.prevent="changePage(data.currentPage + 1)">Next</button>
						</li>
					</ul>
				</div>
	        </div>
	    </div>
	</div>
</template>

<script>
export default {
	props: [ 'data' ],
	data() {
		return {
			limit: 10
		}
	},
	methods: {
		isCurrentPage(page){
			return this.data.currentPage === page
		},
		changePage(page) {
			if (page === '...') {
				return;
			}
			if (page > this.data.totalPages) {
				page = this.data.totalPages;
			}
			this.data.currentPage = page;
			this.$root.$emit('paginate', page);
		}
	},
	computed: {
		pages() {
			let current         = this.data.currentPage
			let last            = this.data.totalPages
			let delta           = 2
			let left            = current - delta
			let right           = current + delta + 1
			let range           = []
			let rangeWithDots   = []  
			let l               = 0              

			for (let i = 1; i <= last; i++) {
				if (i == 1 || i == last || i >= left && i < right) {
					range.push(i);
				}
			}

			for (let i of range) {
				if (l) {
					if (i - l === 2) {
						rangeWithDots.push(l + 1);
					} else if (i - l !== 1) {
						rangeWithDots.push('...');
					}
				}
				rangeWithDots.push(i);
				l = i;
			}

			return rangeWithDots;
		}
	},
	watch: {
		limit: function(){
			let _ = this
			_.$root.$emit('changeLimit', _.limit)
		}
	}
}
</script>